export const STORE_FRONT_URL = 'https://www.amazon.in/s?i=merchant-items&me=AFPA3TZBUMA17'
export const SITE_URL = 'https://saffronleo.in'
export const SOCIAL_INSTAGRAM = 'https://www.instagram.com/saffronleo/'
export const SUPPORT_EMAIL = 'contact@saffronleo.in'
export const SUPPORT_PHONE = '+91 88907 99893'
export const OG_IMAGE_HOME = '/assets/brand/og/home-1200x630.jpg'
export const SHIPPING = {
  country: 'IN',
  handlingMinDays: 0,
  handlingMaxDays: 2,
  transitMinDays: 2,
  transitMaxDays: 7,
}
export const RETURN_POLICY = {
  days: 7,
  category: 'https://schema.org/MerchantReturnFiniteReturnWindow',
}
